import { Box, Typography } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import CustomFormikField from "../../formik/CustomFormikField";
import { useUsernameAvailability } from "./hooks/useUsernameAvailability";

// Signup username input with a live green/red/amber availability indicator.
const UsernameField = (props) => {
  const { t } = useTranslation("signup");
  const { values } = useFormikContext();
  const status = useUsernameAvailability(values?.username);

  const RED = "#FE1F02";
  const GREEN = "#1E9E52";
  const AMBER = "#B4650A";
  const GREY = "#6b7280";

  const indicator = {
    checking: {
      color: GREY,
      icon: null,
      text: t("availability.checking"),
    },
    available: {
      color: GREEN,
      icon: <CheckCircleRoundedIcon sx={{ fontSize: 16 }} />,
      text: t("availability.available"),
    },
    taken: {
      color: RED,
      icon: <CancelRoundedIcon sx={{ fontSize: 16 }} />,
      text: t("availability.taken"),
    },
    invalid_format: {
      color: AMBER,
      icon: <ReportProblemRoundedIcon sx={{ fontSize: 16 }} />,
      text: t("availability.invalidFormat"),
    },
    inappropriate: {
      color: RED,
      icon: <CancelRoundedIcon sx={{ fontSize: 16 }} />,
      text: t("availability.inappropriate"),
    },
    too_short: {
      color: AMBER,
      icon: <ReportProblemRoundedIcon sx={{ fontSize: 16 }} />,
      text: t("availability.tooShort"),
    },
    too_long: {
      color: AMBER,
      icon: <ReportProblemRoundedIcon sx={{ fontSize: 16 }} />,
      text: t("availability.tooLong"),
    },
  }[status];

  return (
    <Box>
      <CustomFormikField name="username" {...props} />
      {indicator && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5, ml: 0.5 }}>
          {indicator.icon}
          <Typography variant="caption" sx={{ color: indicator.color, fontWeight: 600 }}>
            {indicator.text}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default UsernameField;
